import { toSsnFormat } from './date-utils'

export const ssnErrorMessage = (error: string) => {
  if (error === '5100') {
    return 'En profil med samme fødselsnummer og dato finnes allerede'
  }
  if (error === '5101') {
    return 'Ugyldig personnummer og fødselsdato'
  }
  return undefined
}

export const validateSsn = (
  dateOfBirth: Date,
  ssn: string
): { valid: false; message: string } | { valid: true } => {
  if (parseInt(ssn, 10) < 0) {
    return { valid: true }
  }

  const validFormat = validateFormat(ssn)
  if (!validFormat.valid) return validFormat

  const validDigits = validateSsnDigits(dateOfBirth, ssn)
  if (!validDigits.valid) return validDigits

  return { valid: true }
}

const validateFormat = (ssn: string): { valid: false; message: string } | { valid: true } => {
  if (!RegExp('^(\\d{5})?$').test(ssn)) {
    return {
      valid: false,
      message: 'Personnummer skal bestå av 5 tall',
    }
  }
  return { valid: true }
}

const validateSsnDigits = (
  dateOfBirth: Date,
  ssn: string
): { valid: false; message: string } | { valid: true } => {
  const firstDigits = parseInt(ssn.substr(0, 3), 10)
  const k1 = parseInt(ssn.substr(3, 1), 10)
  const k2 = parseInt(ssn.substr(4, 1), 10)

  const inRange1900 =
    inRange(dateOfBirth.getFullYear(), 1900, 1999) &&
    (inRange(firstDigits, 0, 499) || inRange(firstDigits, 900, 999))
  const inRange2000 = inRange(dateOfBirth.getFullYear(), 2000, 2039) && inRange(firstDigits, 500, 999)

  const checkSum = generateCheckSum(toSsnFormat(dateOfBirth), ssn)
  const hasCorrectCheckSum = checkSum.sum1 === k1 && checkSum.sum2 === k2

  if (!(inRange1900 || inRange2000) || !hasCorrectCheckSum) {
    return {
      valid: false,
      message: 'Personnummer er ikke gyldig',
    }
  }
  return { valid: true }
}

const generateCheckSum = (dateOfBirth: string, ssn: string) => {
  const d1 = parseInt(dateOfBirth.substr(0, 1), 10)
  const d2 = parseInt(dateOfBirth.substr(1, 1), 10)
  const m1 = parseInt(dateOfBirth.substr(2, 1), 10)
  const m2 = parseInt(dateOfBirth.substr(3, 1), 10)
  const y1 = parseInt(dateOfBirth.substr(4, 1), 10)
  const y2 = parseInt(dateOfBirth.substr(5, 1), 10)

  const i1 = parseInt(ssn.substr(0, 1), 10)
  const i2 = parseInt(ssn.substr(1, 1), 10)
  const i3 = parseInt(ssn.substr(2, 1), 10)

  const chksum1 = (3 * d1 + 7 * d2 + 6 * m1 + 1 * m2 + 8 * y1 + 9 * y2 + 4 * i1 + 5 * i2 + 2 * i3) % 11
  const k1Calc = chksum1 === 0 ? 0 : 11 - chksum1
  const chksum2 =
    (5 * d1 + 4 * d2 + 3 * m1 + 2 * m2 + 7 * y1 + 6 * y2 + 5 * i1 + 4 * i2 + 3 * i3 + 2 * k1Calc) % 11
  const k2Calc = chksum2 === 0 ? 0 : 11 - chksum2

  return {
    sum1: k1Calc,
    sum2: k2Calc,
  }
}

const inRange = (x: number, min: number, max: number) => {
  return (x - min) * (x - max) <= 0
}
